// 存储安装提示事件
let deferredPrompt;

// 初始化PWA安装功能
export function initPwaInstall() {
  // 在开发环境下不启用PWA
  if (process.env.NODE_ENV === 'development') {
    console.log('开发环境下不启用PWA功能');
    return;
  }
  
  // 监听beforeinstallprompt事件
  window.addEventListener('beforeinstallprompt', (e) => {
    // 阻止Chrome 67及更早版本自动显示安装提示
    e.preventDefault();
    // 保存事件以便稍后触发
    deferredPrompt = e;
    console.log('PWA安装准备就绪');
  });

  // 安装完成后的事件
  window.addEventListener('appinstalled', () => {
    // 清理保存的安装提示
    deferredPrompt = null;
    console.log('PWA已成功安装');
  });
}

// 触发PWA安装
export function installPwa() {
  // 在开发环境下不执行安装
  if (process.env.NODE_ENV === 'development') {
    console.log('开发环境下不支持PWA安装');
    alert('开发环境下不支持应用安装');
    return;
  }

  if (!deferredPrompt) {
    console.log('没有可用的安装提示，可能PWA已安装或不符合安装条件');
    alert('该设备当前不支持安装应用或应用已安装');
    return;
  }

  // 显示安装提示
  deferredPrompt.prompt();

  // 等待用户响应
  deferredPrompt.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === 'accepted') {
      console.log('用户接受PWA安装');
    } else {
      console.log('用户拒绝PWA安装');
    }
    // 清理
    deferredPrompt = null;
  });
}

// 检查PWA是否可安装
export function isPwaInstallable() {
  // 在开发环境下始终返回false
  if (process.env.NODE_ENV === 'development') {
    return false;
  }
  return !!deferredPrompt;
}